export const SOFTLINE_FEATURE_GOLDSCHMIEDE_AUFTRAG = 'goldschmiedeAuftrag';
export const SOFTLINE_PERMISSION_GOLDSCHMIEDE = 'GOLDSCHMIEDE';
